// extracted by mini-css-extract-plugin
module.exports = {"actions":"seance-actions_actions__b_d_k","log":"seance-actions_log__XlHYm"};